import "./footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-content">Copyright © 2024</p>
      <p className="footer-content">
        <a href="/">Ratan</a>
      </p>
    </div>
  );
};
